import { render, staticRenderFns } from "./addBankDc.vue?vue&type=template&id=3dcee034&scoped=true"
import script from "./addBankDc.vue?vue&type=script&lang=js"
export * from "./addBankDc.vue?vue&type=script&lang=js"
import style0 from "./addBankDc.vue?vue&type=style&index=0&id=3dcee034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcee034",
  null
  
)

export default component.exports